// UI-related constants for consistent styling and behavior

// Dashboard Tab Names
export const DASHBOARD_TABS = {
  DASHBOARD: 'dashboard',
  BOOKINGS: 'bookings',
  USERS: 'users',
  SERVICES: 'Services',
  REPORTS: 'reports',
  SETTINGS: 'settings',
  CUSTOMERS: 'customers'
};

// Active Tab Styles
export const TAB_STYLES = {
  ACTIVE: 'text-blue-500 border-b-2 border-blue-500',
  INACTIVE: 'text-gray-500 hover:text-gray-700',
  BASE: 'py-2 px-3 md:px-4 text-sm md:text-base whitespace-nowrap'
};

// Loading Spinner Sizes
export const SPINNER_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

// Loading Spinner Colors
export const SPINNER_COLORS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  DANGER: 'danger'
};

// Common CSS Classes
export const CSS_CLASSES = {
  BUTTON_PRIMARY: 'bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700',
  BUTTON_SECONDARY: 'bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700',
  BUTTON_SUCCESS: 'bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700',
  BUTTON_DANGER: 'bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700',
  INPUT_BASE: 'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500',
  CARD_BASE: 'bg-white rounded-lg shadow-md p-6',
  ERROR_TEXT: 'text-red-600',
  SUCCESS_TEXT: 'text-green-600',
  WARNING_TEXT: 'text-yellow-600'
};

// Modal Sizes
export const MODAL_SIZES = {
  SMALL: 'max-w-md',
  MEDIUM: 'max-w-lg',
  LARGE: 'max-w-2xl',
  EXTRA_LARGE: 'max-w-4xl'
};

// Common View States
export const VIEW_STATES = {
  PROFILE: 'profile',
  BOOKINGS: 'bookings',
  SETTINGS: 'settings'
};

// Filter Options
export const FILTER_OPTIONS = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

// Calendar Resource Area
export const CALENDAR_CONFIG = {
  RESOURCE_AREA_HEADER: 'Staff',
  DEFAULT_VIEW: 'timeGridWeek'
};

// Form Field Types
export const FIELD_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  PASSWORD: 'password',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  DATE: 'date',
  TIME: 'time',
  NUMBER: 'number',
  CHECKBOX: 'checkbox'
};